import SimpleLightbox from "simplelightbox";

window.addEventListener('DOMContentLoaded', function(){

    let blocks = document.querySelectorAll('.gallery-filter-block');

    if(blocks){

        blocks.forEach(function(block){

            // start gallery

            const args = {
                animationSlide: false,
                fadeSpeed: 150,
                animationSpeed: 150,
                spinner: false,
                showCounter: false,
                captions: true,
                scrollZoom: false,
                showCounter: true,
                nav: true,
                loop: true,
                overlayOpacity: 0.9,
                disableRightClick: true,
                navText: [ 
                    '<svg xmlns="http://www.w3.org/2000/svg" height="20" width="12.5" viewBox="0 0 320 512"><!--!Font Awesome Pro v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2026 Fonticons, Inc.--><path d="M7.5 239c-9.4 9.4-9.4 24.6 0 33.9l200 200c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183 183-183c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7.5 239z"/></svg>',
                    '<svg xmlns="http://www.w3.org/2000/svg" height="20" width="12.5" viewBox="0 0 320 512"><!--!Font Awesome Pro v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2026 Fonticons, Inc.--><path d="M313.5 239c9.4 9.4 9.4 24.6 0 33.9l-200 200c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l183-183-183-183c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l200 200z"/></svg>'
                ],
                closeText: '<svg xmlns="http://www.w3.org/2000/svg" height="20" width="15" viewBox="0 0 384 512"><!--!Font Awesome Pro v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2026 Fonticons, Inc.--><path d="M7.5 105c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l151 151 151-151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-151 151 151 151c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-151-151-151 151c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l151-151-151-151z"/></svg>'
            };

            let galleryFilter = new SimpleLightbox( `#${block.id} .gallery-filter-block--image a` , args );
            
            const form = block.querySelector('form');
            
            form.addEventListener('change', function(e){

                if (e.target.name === 'gallery-filter') {
                    
                    const value = e.target.value;
                    let gallerySelector = `#${block.id} .gallery-filter-block--image`;

                    if( 'all' == value ){
                        block.querySelectorAll('.gallery-filter-block--image').forEach( image => {
                            
                            if( 'block' != image.style.display ){
                                image.style.opacity = 0;
                                image.style.display = 'block'
                            }
                            
                            setTimeout( () => image.style.opacity = 1 , 200 );
                            
                        } );
                    }else{

                        // hide images
                        block.querySelectorAll(`.gallery-filter-block--images > div:not(.${value})`).forEach( image => image.style.display = 'none' );
    
                        // show images
                        block.querySelectorAll(`.gallery-filter-block--images > div.${value}`).forEach( image => {
    
                            if( 'none' == image.style.display ){
                                image.style.opacity = 0;
                                image.style.display = 'block'
                            }
                            
                            setTimeout( () => image.style.opacity = 1, 200 );
    
                        } );

                        gallerySelector = gallerySelector + '.' + value;

                    }
                    
                    // update gallery lightbox (only show filtered images)
                    galleryFilter.destroy();
                    galleryFilter = new SimpleLightbox( gallerySelector + ' a' , args );

                }
            })
        });
    }
});